@if ((selectedLanguage$ | async); as selectedLanguage) {
  <div class="nav-item dropdown nav-item-language">
    <a class="nav-link dropdown-toggle language" href="#" id="languageDropdown" role="button" data-bs-toggle="dropdown"
      aria-expanded="false">
      <img class="me-1" src="assets/images/header/{{ selectedLanguage }}.svg" alt="{{ 'Language' | translate }}" />{{
      selectedLanguage | translate }}
    </a>
    <ul class="dropdown-menu dropdown-menu-md-end" aria-labelledby="navbarDropdown">
      @for (language of (languages$ | async); track language.code) {
        <li>
          <a class="dropdown-item" id="{{ 'ls-' + language.code }}" (click)="changeLanguage(language.code)"
          (keydown.enter)="changeLanguage(language.code)" tabindex="0" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">{{ language.shortName | translate }}</a>
        </li>
      }
    </ul>
  </div>
}
